{
  "navigation": {
    "current": "Current",
    "schedule": "Schedule",
    "tenants": "Tenants",
    "opsCenter": "Ops Center",
    "hangars": "Hangars",
    "ramps": "Ramps",
    "aircraft": "Aircraft",
    "tripSchedule": "Trip Schedule",
    "ops": "Ops",
    "feeCalculator": "Fee Calculator",
    "hangarOptimization": "Hangar Optimization Calculator",
    "help": "Help",
    "superAdmin": "Super Admin",
    "settings": "Settings",
    "logout": "Logout",
    "logoAlt": "AirPLX Logo"
  },
  "timeControl": {
    "prevTrip": "Prev Trip",
    "nextTrip": "Next Trip",
    "now": "Now",
    "today": "Today",
    "daily": "Daily",
    "15m": "15m",
    "previousDay": "Previous day",
    "nextDay": "Next day",
    "viewSchedule": "View Schedule",
    "timeSelectionAriaLabel": "Time selection slider",
    "tripDurationTitle": "Selected aircraft trip duration",
    "noPreviousTrips": "No earlier trips",
    "noPreviousTripsForAircraft": "No earlier trips for {{tailNumber}}",
    "jumpToPreviousTrip": "Jump to previous trip",
    "jumpToPreviousTripForAircraft": "Jump to previous trip for {{tailNumber}}",
    "noFutureTrips": "No future trips",
    "noFutureTripsForAircraft": "No future trips for {{tailNumber}}",
    "jumpToNextTrip": "Jump to next trip",
    "jumpToNextTripForAircraft": "Jump to next trip for {{tailNumber}}"
  },
  "tripListDisplay": {
    "noTripsFound": "No trips found",
    "noOwner": "No owner"
  },
  "bulkApplyFloatingAction": {
    "applyButton": "Apply",
    "message": "Bulk Apply Floating Action"
  },
  "dimensionInput": {
    "currentPrefix": "Current:",
    "errorMessage": "Invalid dimension",
    "unit": "ft"
  },
  "equipmentTable": {
    "nameHeader": "Name",
    "lengthHeader": "Length",
    "widthHeader": "Width",
    "heightHeader": "Height",
    "towBarHeader": "Tow Bar",
    "actionsHeader": "Actions",
    "editButton": "Edit",
    "deleteButton": "Delete"
  },
  "obstaclePreview": {
    "title": "Obstacle Preview",
    "emptyState": "Select an obstacle to preview",
    "noImageAvailable": "No image available",
    "dimensionsLabel": "Dimensions",
    "lengthLabel": "Length",
    "widthLabel": "Width",
    "heightLabel": "Height",
    "unit": "ft"
  },
  "obstacleTable": {
    "nameHeader": "Name",
    "lengthHeader": "Length",
    "widthHeader": "Width",
    "heightHeader": "Height",
    "actionsHeader": "Actions",
    "editButton": "Edit",
    "deleteButton": "Delete"
  },
  "recentPatternsPanel": {
    "title": "Recent Patterns",
    "lastPrefix": "Last:",
    "appliedSuffix": "applied",
    "never": "Never",
    "reApplyButton": "Re-apply",
    "unknownAircraft": "Unknown Aircraft"
  },
  "vipTagSelect": {
    "label": "Tags",
    "addTag": "Add Tag",
    "editTags": "Edit Tags",
    "noTags": "No tags"
  },
  "notFoundCard": {
    "hangarTitle": "Hangar Not Found",
    "rampTitle": "Ramp Not Found",
    "hangarMessage": "The hangar you're looking for doesn't exist or you no longer have access.",
    "rampMessage": "The ramp you're looking for doesn't exist or you no longer have access.",
    "goToHangars": "Go to Hangars",
    "goToRamps": "Go to Ramps"
  },
  "activation": {
    "title": "Get Started",
    "subtitle": "5 steps to become an AirPlx pro",
    "steps": {
      "addAircraft": {
        "title": "Add an aircraft",
        "description": "Add a tenant aircraft to your hangar"
      },
      "firstAutostack": {
        "title": "Run AutoStack",
        "description": "Let the algorithm arrange your aircraft"
      },
      "secondAutostack": {
        "title": "Try a different scenario",
        "description": "Run AutoStack again with different aircraft"
      },
      "saveFavorite": {
        "title": "Save a layout",
        "description": "Create a favorite to reference later"
      },
      "shareLayout": {
        "title": "Share with your team",
        "description": "Print, copy link, or email the layout"
      },
      "runAutostack": "Continue"
    },
    "progress": "{{completed}} of {{total}} complete",
    "dismiss": "Dismiss for now",
    "completed": "Completed",
    "complete": {
      "title": "You're all set!",
      "message": "You've completed the setup. AirPlx is ready to help you plan.",
      "dismiss": "Got it"
    }
  }
}
